module.exports = __webpack_public_path__ + "img/jingdiangushi@3x.3b5d5332.png";